import React from "react";
import { useTranslate } from "react-admin";

const IncidentTitle = ({ record }) => {
    const translate = useTranslate();

    return (
        <span>
            {
                ! record ?    translate("incident.message.list") :
                ! record.id ? translate("incident.message.new") :
                              translate("incident.message.instance", { ...record })
            }
        </span>
    );
}

export default IncidentTitle;
